import React from "react";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Box, Typography } from "@mui/material";
import { auditDashboardTheme } from "../../theme";

export default function AuditDayInProgressEmptyState() {
  return (
    <Box
      sx={{
        minHeight: 320,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 440,
          display: "grid",
          justifyItems: "center",
          gap: "10px",
          px: 3,
          py: 3,
          border: "1px solid rgba(223, 148, 0, 0.22)",
          borderRadius: "12px",
          bgcolor: auditDashboardTheme.colors.amberSoft,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: auditDashboardTheme.colors.textProgress,
            bgcolor: "rgba(162, 104, 8, 0.1)",
          }}
        >
          <AccessTimeOutlinedIcon sx={{ fontSize: 22 }} />
        </Box>
        <Typography
          component="h3"
          sx={{
            color: auditDashboardTheme.colors.text,
            fontSize: 18,
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          Your day is in progress!
        </Typography>
        <Typography
          component="p"
          sx={{
            m: 0,
            color: auditDashboardTheme.colors.textMutedStrong,
            fontSize: 13,
            fontWeight: 500,
            lineHeight: 1.4,
          }}
        >
          You haven't submitted any audits yet.
          <br />
          Submitted audits will appear here once completed.
        </Typography>
      </Box>
    </Box>
  );
}
